function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "43. Ambulance car");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_43._Ambulance_car",
  "data-name": "43. Ambulance car"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M48,29.76a7.43,7.43,0,0,0-3.54-4.65c-1.42-.8-1.86-.75-8.94-2-5.38-5.37-6-6.45-8.68-6.95L26,12.76A1,1,0,0,0,25,12H21a1,1,0,0,0-1,.76L19.22,16H3a3,3,0,0,0-3,3V35a3,3,0,0,0,3,3H6.1a5,5,0,0,0,9.8,0H32.1a5,5,0,0,0,9.8,0H45a3,3,0,0,0,3-3C48,29.63,48,29.93,48,29.76ZM43.72,27a5,5,0,0,1,1.81,2H44A1,1,0,0,1,43.72,27ZM32.59,23H24V18C28.24,18,27.79,18.21,32.59,23ZM21.78,14h2.44l.5,2H21.28ZM11,40a3,3,0,1,1,3-3A3,3,0,0,1,11,40Zm26,0a3,3,0,1,1,3-3A3,3,0,0,1,37,40Zm8-4H41.9a5,5,0,0,0-9.8,0H15.9a5,5,0,0,0-9.8,0H3a1,1,0,0,1-1-1V32H3a1,1,0,0,0,0-2H2V19a1,1,0,0,1,1-1H22v5a2,2,0,0,0,2,2c13.09,0,9.17-.31,17.6,1.21A3,3,0,0,0,44,31h2v4A1,1,0,0,1,45,36Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M37.92,36.62A1,1,0,1,0,37,38,1,1,0,0,0,37.92,36.62Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M10.8,36a1,1,0,1,0,.58,1.9A1,1,0,0,0,10.8,36Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M15,22H14V21a1,1,0,0,0-1-1H9a1,1,0,0,0-1,1v1H7a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H8v1a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V28h1a1,1,0,0,0,1-1V23A1,1,0,0,0,15,22Zm-1,4H13a1,1,0,0,0-1,1v1H10V27a1,1,0,0,0-1-1H8V24H9a1,1,0,0,0,1-1V22h2v1a1,1,0,0,0,1,1h1Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M27,27H25a1,1,0,0,0,0,2h2A1,1,0,0,0,27,27Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M24,9V7a1,1,0,0,0-2,0V9A1,1,0,0,0,24,9Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M18.05,11.46a1,1,0,0,0,1.41-1.41L18.05,8.64a1,1,0,0,0-1.41,1.41Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M27.24,11.76c.6,0,.83-.42,2.12-1.71A1,1,0,1,0,28,8.64l-1.41,1.41A1,1,0,0,0,27.24,11.76Z"
}));

var SvgAmbulanceCar = function SvgAmbulanceCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAmbulanceCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AmbulanceCar.dcc64aab.svg";
export { ForwardRef as ReactComponent };